import React, { useEffect, useState } from "react";
import classes from "./SideMenu.module.css";
import SideMenuData from "./SideMenuData";
import { GrClose } from "react-icons/gr";
import useHttp from "../../Hooks/use-http";
import Cookies from "js-cookie";
import { useFirstUrl } from "../../Context/FirstUrlContext";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

let flag = false;

const SideMenu = (props) => {
  const [sideMenuData, setSideMenuData] = useState([]);
  const { sendRequest } = useHttp();
  const { firstUrl, setFirstUrl } = useFirstUrl();
  const history = useHistory();

  const menuList = (data) => {
    // Check if API response indicates failure
    if (
      (data.status != "200" && data.status != "201") ||
      !data.PanelModuleDetails ||
      data.PanelModuleDetails.length === 0
    ) {
      handleLogout();
      return; // Exit early if API failed
    }
    const panelMap = {};
    let firstValidUrl = null;

    // Group data by panelID
    data?.PanelModuleDetails?.forEach((item) => {
      const { panelID, moduleID, moduleURL, moduleName, moduleIcon } = item;

      // Check if this is the first valid URL we've encountered
      if (!firstValidUrl && moduleURL) {
        firstValidUrl = moduleURL;
      }

      // Initialize an array for the panelID if it doesn't exist
      if (!panelMap[panelID]) {
        panelMap[panelID] = [];
      }

      // Push the moduleID and moduleURL
      panelMap[panelID].push({ moduleID, moduleURL, moduleName, moduleIcon });
    });

    if (firstValidUrl && !firstUrl) {
      setFirstUrl(firstValidUrl);
    }

    // Now, map panelMap to the desired structure
    const menu = Object.entries(panelMap).map(([panelID, modules]) => {
      if (modules.length === 1 && modules[0].moduleURL) {
        return {
          main: modules[0].moduleID,
          url: modules[0].moduleURL,
          name: modules[0]?.moduleName,
          icon: modules[0]?.moduleIcon || null,
        };
      } else {
        return {
          main: panelID,
          icon: modules[0]?.moduleIcon,
          sub: modules.map((mod) => ({
            main: mod.moduleID,
            url: mod.moduleURL || null,
            name: mod?.moduleName,
            icon: modules[0]?.moduleIcon,
          })),
        };
      }
    });

    setSideMenuData(menu);
  };

  // Add error handler function
  const handleError = (error) => {
    console.error("API request failed:", error);
    handleLogout();
  };

  const handleLogout = () => {
    Cookies.remove("token");
    localStorage.removeItem("login");
    localStorage.removeItem("userType");
    localStorage.removeItem("user");
    localStorage.removeItem("roleId");
    localStorage.removeItem("adminName");
    localStorage.removeItem("corpId");
    localStorage.removeItem("cpName");

    toast.error("Please Log in again, after some time.");
    history.push("/home");
  };

  useEffect(() => {
    sendRequest(
      {
        url: "/panelmoduledetails",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          roleID: localStorage.getItem("roleId"),
        },
      },
      menuList,
      handleError
    );
  }, []);

  const changeMenuWidth = () => {
    const sideMenuElement = document.getElementById("mySidemenu");

    // Ensure the element exists before proceeding
    if (!sideMenuElement) {
      console.warn("SideMenu element not found.");
      return;
    }

    if (window.screen.width < 450) {
      sideMenuElement.style.width = "100%";
      sideMenuElement.style.minWidth = "100%";
    } else {
      sideMenuElement.style.width = "25%";
      sideMenuElement.style.minWidth = "25%";
    }
  };

  useEffect(() => {
    const sideMenuElement = document.getElementById("mySidemenu");

    // Ensure the element exists before trying to access it
    if (props.property && sideMenuElement) {
      if (window.screen.width < 450) {
        sideMenuElement.style.width = "100%";
      } else {
        sideMenuElement.style.width = "20%";
      }

      window.addEventListener("popstate", changeMenuWidth);
      flag = true;
    } else if (flag && sideMenuElement) {
      sideMenuElement.style.minWidth = "0px";
      sideMenuElement.style.width = "0px";
    }

    // Clean up event listener when the component unmounts
    return () => {
      window.removeEventListener("popstate", changeMenuWidth);
    };
  }, [props.property]);

  return (
    <div className={classes.menuContainer} id="mySidemenu">
      <div
        className={classes.subMenu}
        onMouseLeave={() => props.sideMenuClose()}
      >
        <div
          className={classes.closeIcon}
          onClick={() => props.sideMenuClose()}
        >
          <GrClose />
        </div>
        {sideMenuData?.length === 0 && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            No Data Available
          </div>
        )}
        {sideMenuData?.length > 0 && (
          <SideMenuData
            menu={sideMenuData}
            iconFlag={true}
            sideMenuClose={props.sideMenuClose}
          />
        )}
        <p
          style={{
            color: "gray",
            marginTop: "20%",
            fontSize: "10px",
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          Last Updated on 22/07/2026
        </p>
      </div>
    </div>
  );
};

export default SideMenu;
